import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewChartComponent } from './ui/new-chart/new-chart.component';
import { ChartHeaderComponent } from './ui/chart-header/chart-header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NewChartBaseComponent } from './utils/new-chart-base.component';
import { PdfChartExporterComponent } from './ui/pdf-chart-exporter/pdf-chart-exporter.component';
import { ThemeModule } from '../Theme/theme.module';
import { ZenChartModule } from '@ex/module/core/modules/chart/chart.module';
import { CircleComponent } from './ui/mini-charts/circle/circle.component';
import { GaugeComponent } from './ui/mini-charts/gauge/gauge.component';




@NgModule({
  declarations: [
    NewChartComponent,
    ChartHeaderComponent,
    NewChartBaseComponent,
    PdfChartExporterComponent,
    GaugeComponent,
    CircleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ZenChartModule,
    ReactiveFormsModule,
    ThemeModule,
  ],
  exports: [
    NewChartComponent,
    ChartHeaderComponent,
    PdfChartExporterComponent,
    GaugeComponent,
    CircleComponent
  ]
})
export class ChartModule { }
